import { ITableConfig } from "@/components/table/table.model";
import { SORTING_DIR } from "@/common/models";

export const table_config: ITableConfig = {
  columns: [
    /*   {
      name: "",
      key: "",
      sortable: false,
      sortDir: SORTING_DIR.ASC,
      filterable: false,
      spanMin: "3rem",
      spanMax: "3rem",
    }, */
    {
      name: "File Name",
      key: "file_name",
      sortable: true,
      sortDir: SORTING_DIR.ASC,
      filterable: false,
      spanMin: "25rem",
      spanMax: "1.2fr",
    },

    {
      name: "Information type",
      key: "label",
      spanMin: "15rem",
      spanMax: "1.2fr",
      sortable: false,
      filterable: false,
      sortDir: SORTING_DIR.ASC,
      isSortActive: false,
      jsPath: "$[*].label",
    },
    {
      name: "PIIs",
      key: "piis",
      spanMin: "15rem",
      spanMax: "1fr",
      sortable: false,
      filterable: false,
      sortDir: SORTING_DIR.ASC,
      isSortActive: false,
      jsPath: "$[*].label",
    },
    {
      name: "Sensitivity",
      key: "sensitivity",
      spanMin: "10rem",
      spanMax: "10rem",
      sortable: false,
      filterable: false,
      sortDir: SORTING_DIR.ASC,
      isSortActive: false,
      jsPath: "$[*].sensitivity",
    },
    {
      name: "Storage",
      key: "storage_name",
      sortable: true,
      sortDir: SORTING_DIR.ASC,
      filterable: false,
      spanMin: "15rem",
      spanMax: "1fr",
    },
    {
      name: "File Share Name",
      key: "file_share_name",
      sortable: true,
      sortDir: SORTING_DIR.ASC,
      filterable: false,
      spanMin: "10rem",
      spanMax: "1fr",
    },
    {
      name: "Folder",
      key: "folder_name",
      sortable: true,
      sortDir: SORTING_DIR.ASC,
      filterable: false,
      spanMin: "20rem",
      spanMax: "1fr",
    },
  ],
};
